import {
	WidgetInputColorField,
	WidgetInputColorFieldProps,
} from '../../rapid-ui/inputs/widgets/widget-input-color-field'

export type WidgetColorFieldProps = WidgetInputColorFieldProps & {
	hidePresets?: boolean
	presets?: Array<{
		label: string
		value: string
		displayColor: string
	}>
}

export function WidgetColorField(
	{ value, onChange, label, hidePresets = false, isGenerating = false, presets = [] }: WidgetColorFieldProps,
) {
	return (
		<WidgetInputColorField
			value={value}
			onChange={onChange}
			label={label}
			isGenerating={isGenerating}
			presets={hidePresets ? [] : presets}
		/>
	)
}
